import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ContentLeft from './components/ContentLeft';
import Testimonials from './components/Testimonials';
import ContentRight from './components/ContentRight';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <ContentLeft />
      <Testimonials />
      <ContentRight />
      <Gallery />
      <Contact />
      <CookieConsent />
      <Footer />
    </div>
  );
}

export default App;
